import { http } from '@/services/http/api-client';

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export const passwordApi = {
  /** 204. Signs out the caller's other sessions; this one stays signed in. */
  change: (body: ChangePasswordRequest) => http.post<void>('/auth/change-password', body),
};
